import { UseCase } from './UseCase';
import { MessageForPlayer, noCleavagePleaseWait } from '../entities/MessageForPlayer';
import { waitForCleavageLaunchMessage } from '../entities/playerMessages';
import { GamePhase } from '../entities/GamePhase';
export class PlayerCleaveUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return this.applicationServices.player.addPlayer(event.username)
            .then(() => this.applicationServices.cleavage.retrieveCurrentGamePhase())
            .then(currentGamePhase => currentGamePhase !== GamePhase.CLEAVING
            ? this.applicationServices.chat.sendMessageToPlayer(new MessageForPlayer(event.username, waitForCleavageLaunchMessage))
            : this.onCleavingPhase(event))
            .catch(error => Promise.reject(error));
    }
    onCleavingPhase(event) {
        return this.applicationServices.cleavage.hasCurrentCleavage()
            .then(hasCleavage => hasCleavage
            ? this.onCleavage(event)
            : this.applicationServices.chat.sendMessageToPlayer(noCleavagePleaseWait(event.username)))
            .catch(error => Promise.reject(error));
    }
    onCleavage(event) {
        return this.applicationServices.cleavage.playerCleave(event)
            .then(() => this.updateCleavageOnInterface())
            .catch(error => Promise.reject(error));
    }
    updateCleavageOnInterface() {
        return this.applicationServices.cleavage.loadCurrentCleavage()
            .then(cleavage => this.applicationServices.interface.updateCleavage(cleavage))
            .catch(error => Promise.reject(error));
    }
}
